"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = DuplexBanner;
const react_1 = __importDefault(require("react"));
const Button_1 = require("@JohnLewisPartnership/jl-design-system/dist/components/button/Button");
const DuplexBanner_module_scss_1 = __importDefault(require("./DuplexBanner.module.scss"));
const sanitise_1 = require("../../../utils/sanitise");
const dispatchAnalytics_1 = require("../../../utils/dispatchAnalytics");
const buildImageUrl_1 = require("../../../utils/buildImageUrl");
const Container = ({ ctaLink, className, children, onClick, }) => {
    if (ctaLink) {
        return (react_1.default.createElement("a", { href: ctaLink, className: className, "data-testid": "adtech-banner-link", onClick: onClick }, children));
    }
    return (react_1.default.createElement("div", { className: className, "data-testid": "adtech-banner-container" }, children));
};
function DuplexBanner({ associatedAdvertId, logoImage, logoAccessibilityText, title, ctaLink, ctaText, desktopImage, mobileImage, accessibilityText, description, backgroundColour, textColour, previewerSize, clickUrl, impressionUrl, esiType, }) {
    const TITLE_CHAR_LIMIT = 32;
    const DESC_CHAR_LIMIT = 102;
    const DEFAULT_TEXT_COLOUR = "#5B5B5B";
    const DEFAULT_BACKGROUND_COLOUR = "#F8F7F7";
    const color = (0, sanitise_1.sanitiseColor)(textColour !== null && textColour !== void 0 ? textColour : DEFAULT_TEXT_COLOUR);
    // lg/xl breakpoint crop
    const desktopSrc = (0, buildImageUrl_1.buildImageUrl)(desktopImage, { fmt: "auto", wid: "1532", sm: "aspect", aspect: "1532:536" }, { applyPoi: true });
    // sm/md breakpoint crop
    const mobileSrc = (0, buildImageUrl_1.buildImageUrl)(mobileImage, { fmt: "auto", wid: "614", sm: "aspect", aspect: "614:422" }, { applyPoi: true });
    let bannerClassName = DuplexBanner_module_scss_1.default.banner;
    let contentClassName = DuplexBanner_module_scss_1.default.content;
    let containerClassName = DuplexBanner_module_scss_1.default.container;
    let headerClassName = DuplexBanner_module_scss_1.default.header;
    let textGroupClassName = DuplexBanner_module_scss_1.default.textGroup;
    let logoClassName = DuplexBanner_module_scss_1.default.logo;
    let titleClassName = DuplexBanner_module_scss_1.default.title;
    let descriptionClassName = DuplexBanner_module_scss_1.default.description;
    let ctaClassName = DuplexBanner_module_scss_1.default.cta;
    let imageContainerClassName = DuplexBanner_module_scss_1.default.imageContainer;
    if (previewerSize) {
        bannerClassName = DuplexBanner_module_scss_1.default[`preview-banner-${previewerSize}`];
        contentClassName = DuplexBanner_module_scss_1.default[`preview-content-${previewerSize}`];
        containerClassName = DuplexBanner_module_scss_1.default[`preview-container-${previewerSize}`];
        headerClassName = DuplexBanner_module_scss_1.default[`preview-header-${previewerSize}`];
        textGroupClassName = DuplexBanner_module_scss_1.default[`preview-textGroup-${previewerSize}`];
        logoClassName = DuplexBanner_module_scss_1.default[`preview-logo-${previewerSize}`];
        titleClassName = DuplexBanner_module_scss_1.default[`preview-title-${previewerSize}`];
        ctaClassName = DuplexBanner_module_scss_1.default[`preview-cta-${previewerSize}`];
        descriptionClassName = DuplexBanner_module_scss_1.default[`preview-description-${previewerSize}`];
        imageContainerClassName = DuplexBanner_module_scss_1.default[`preview-imageContainer-${previewerSize}`];
    }
    return (react_1.default.createElement("div", { className: bannerClassName, "data-testid": "adtech-banner-esi" },
        react_1.default.createElement(Container, { ctaLink: ctaLink, className: containerClassName, onClick: ctaLink
                ? () => {
                    (0, dispatchAnalytics_1.dispatchKevelAnalyticsEvent)({
                        action: "kevel.clicked",
                        type: "banner",
                        adId: associatedAdvertId,
                        clickUrl,
                        impressionUrl,
                        esiType,
                    });
                }
                : undefined },
            react_1.default.createElement("div", { className: contentClassName, style: {
                    backgroundColor: (0, sanitise_1.sanitiseColor)(backgroundColour !== null && backgroundColour !== void 0 ? backgroundColour : DEFAULT_BACKGROUND_COLOUR),
                } },
                react_1.default.createElement("div", { className: headerClassName },
                    (logoImage === null || logoImage === void 0 ? void 0 : logoImage.length) > 0 && (react_1.default.createElement("img", { "data-testid": "adtech-banner-logo", src: logoImage, className: logoClassName, alt: logoAccessibilityText })),
                    react_1.default.createElement("div", { className: textGroupClassName },
                        react_1.default.createElement("p", { "data-testid": "adtech-banner-title", className: titleClassName, style: { color } }, title.substring(0, TITLE_CHAR_LIMIT)),
                        react_1.default.createElement("p", { "data-testid": "adtech-banner-description", className: descriptionClassName, style: { color } }, description === null || description === void 0 ? void 0 : description.substring(0, DESC_CHAR_LIMIT)))),
                ctaLink && ctaLink.length > 0 && (react_1.default.createElement(Button_1.UnderlinedButton, { tag: "span", style: { color }, className: ctaClassName, labelText: ctaText, "data-testid": "adtech-banner-cta" }))),
            react_1.default.createElement("div", { className: imageContainerClassName },
                react_1.default.createElement("picture", null,
                    react_1.default.createElement("source", { "data-testid": "adtech-banner-src-desktop", srcSet: desktopSrc, media: "(min-width: 1280px)" }),
                    react_1.default.createElement("img", { "data-testid": "adtech-banner-image", src: mobileSrc, className: DuplexBanner_module_scss_1.default.image, alt: accessibilityText }))))));
}
